import { createSelector } from '@reduxjs/toolkit';
import { pickingApi } from '../picking.api';
// TODO: to delete comments later if no needed for sure.
// const selectUnblockPickingItemDialogData = (state: RootState) => {
// 	const { data: itemsRequestData, additionalData: { blockedQuantity } = {} } = state.picking.revokePickingItemDialog;
// 	return { ...itemsRequestData, blockedQuantity };
// };
// const selectBlockedItems = (state: RootState, pickingItemId: number | undefined) => {
// 	// if (!pickingItemId) return undefined;
// 	// TODO: to delete
// 	console.log('BLOCKEDITEMS:', pickingApi.endpoints.getPickingItemBlockedItems.select(pickingItemId ? { pickingItemId } : skipToken)(state).data);
// 	return pickingApi.endpoints.getPickingItemBlockedItems.select(pickingItemId ? { pickingItemId } : skipToken)(state).data;
// };
// const selectPickingItem = (state: RootState, pickingItemId: number | undefined, taskId: number | undefined) => {
// 	// if (!taskId) return undefined;
// 	const { items } = pickingApi.endpoints.getPickingTaskItems.select(taskId ? { taskId } : skipToken)(state).data ?? {};
// 	const pickingItem = items?.find((item) => item.id === pickingItemId);
// 	// // TODO: to delete
// 	// console.log('pickingItemId345', pickingItemId);
// 	// console.log('pickingItem', pickingItem);
// 	return pickingItem ? { brand: pickingItem.brand, article: pickingItem.article, name: pickingItem.name } : undefined;
// };
// export const selectReturnedToStockData = createSelector(
// 	[selectUnblockPickingItemDialogData, selectBlockedItems, selectPickingItem],
// 	(unblockPickingItemDialogData, blockedItems, pickingItem) => {
// 		// TODO: to delete
// 		console.count('Output selector running');
// 		const { blockedQuantity: itemBlockedQuantity } = unblockPickingItemDialogData;
// 		const totalBlockedQuantity = blockedItems?.reduce((sum, currentValue) => sum + currentValue.quantity, 0);
// 		// TODO: to delete
// 		console.log('unblockPickingItemDialogData', unblockPickingItemDialogData);
// 		console.log('blockedItems', blockedItems);
// 		// console.log('pickingItem', pickingItem);
// 		const totalReturnedToStockQuantity =
// 			blockedItems && itemBlockedQuantity && totalBlockedQuantity !== undefined ? itemBlockedQuantity - totalBlockedQuantity : undefined;
// 		return { totalReturnedToStockQuantity, pickingItem };
// 	}
// );
const selectPickingItemBlockedQuantity = (state) => {
    return state.picking.revokePickingItemDialog.additionalData?.pickingItemBlockedQuantity;
};
const selectPickingItemAndBlockedItems = (state, blockedItems, taskId) => {
    if (!taskId || !blockedItems)
        return undefined;
    const pickingItemId = state.picking.revokePickingItemDialog.data?.pickingItemId;
    if (!pickingItemId)
        return undefined;
    // TODO: This is RTK Query bug, check if it is fixed and delete ts-ignore
    // @ts-ignore
    const { items } = pickingApi.endpoints.getPickingTaskItems.select({ taskId })(state).data ?? {};
    const pickingItem = items?.find((item) => item.id === pickingItemId);
    if (!pickingItem)
        return undefined;
    return { pickingItem: { brand: pickingItem.brand, article: pickingItem.article, name: pickingItem.name }, blockedItems };
};
export const selectReturnedToStockData = createSelector([selectPickingItemBlockedQuantity, selectPickingItemAndBlockedItems], (pickingItemBlockedQuantity, pickingItemAndBlockedItems) => {
    // (for testing purpose) use when selector is gonna be changed.
    // console.count('Output selector running');
    const { pickingItem, blockedItems } = pickingItemAndBlockedItems ?? {};
    const blockedItemsTotalBlockedQuantity = blockedItems?.reduce((sum, currentValue) => sum + currentValue.quantity, 0);
    const totalReturnedToStockQuantity = blockedItems && pickingItemBlockedQuantity && blockedItemsTotalBlockedQuantity !== undefined
        ? pickingItemBlockedQuantity - blockedItemsTotalBlockedQuantity
        : undefined;
    return { totalReturnedToStockQuantity, pickingItem };
});
